import { Component, OnInit, AfterViewChecked, ElementRef } from '@angular/core';
import { ApiServicesService } from 'src/app/services/apiServices/api-services.service';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { ActivatedRoute, Router } from "@angular/router";
import { RouteConstant } from "src/app/core/_constants/route.constant";
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, FormControl, FormArray, ValidationErrors } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { EditEnquiryComponent } from 'src/app/modules/pages/profile/edit-enquiry/edit-enquiry.component';
import { MatDialog } from '@angular/material/dialog';
import { LogoutComponent } from 'src/app/shared/dialogs/logout/logout.component';
import { ValidationsService } from 'src/app/services/validators/validator';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/services/common.service';
declare var $: any;
@Component({
  selector: 'app-main-home',
  templateUrl: './main-home.component.html',
  styleUrls: ['./main-home.component.scss']
})
export class MainHomeComponent implements OnInit, AfterViewChecked {


  products: any[] = []; // Ensure it's an array
  homeListdata: any;
  //isUserLoggedIn: any;
  recentlyViewedItems: any[] = [];
  bannerListview: any[] = [];
  recommendedProductsItems: any[] = [];
  Enquiriesfrom: FormGroup;
  selectedIndustry: any;
  domUrls: string;
  guestUser: any;
  // commonService: any;
  //dialogRef: any;
  submitted: boolean = false;
  defaultIndustryId: any;






  constructor(private service: ApiServicesService, private commonService: CommonService, private fb: FormBuilder, private Router: ActivatedRoute, private router: Router, private toastr: ToastrService, public datepipe: DatePipe, private el: ElementRef, private dialog: MatDialog,public validators: ValidationsService, public dialogRef: MatDialog,
  ) {
    this.Enquiriesfrom = this.fb.group({
      utm_source: ['',],
      utm_medium: ['',],
      utm_campaign: ['',],
      utm_term: ['',],
      utm_content: ['',],
      utm_placement: ['',],      
      full_name: ['', [Validators.required]],
      mobile_number: ['', [Validators.required]],
      industry_id: [this.defaultIndustryId, Validators.required],
      description: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    const url = new URL(window.location.href);
    const utmsourceValue = url.searchParams.get('utm_source') || ''; 
    const utmMediumValue = url.searchParams.get('utm_medium') || ''; 
    const utmCampaignValue = url.searchParams.get('utm_campaign') || ''; 
    const utmtermValue = url.searchParams.get('utm_term') || ''; 
    const utmcontentValue = url.searchParams.get('utm_content') || ''; 
    const utmplacementValue = url.searchParams.get('utm_placement') || ''; 
    
    // Set the value in the form
    this.Enquiriesfrom.patchValue({ 
      utm_source: utmsourceValue,
      utm_medium: utmMediumValue,
      utm_campaign: utmCampaignValue,
      utm_term: utmtermValue,
      utm_content: utmcontentValue, 
      utm_placement: utmplacementValue 
    });
  
  
    this.homeList();
    this.recentlyViewed();
    this.isUserLoggedIn();
    this.recommendedProducts();
    this.bannerLists();
    this.resgetIndustry();
    this.getProfile();
    // setTimeout(() => {
    //   this.dialogRef.open(LogoutComponent, {
    //     maxHeight: '100vh',
    //     width: '50%',
    //     data: {
    //       images: '../assets/images/new_img/postenquiry.svg',
    //       bigheading: 'Post Your Enquiry',
    //       ques: "Can’t find what you need " + "?",
    //       sol: "Share your enquiry with us, and we’ll help you fulfill it.",
    //       button: "Post Enquiry"
    //     }
    //   })
    // }, 5000);
  }




  restrictInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, ''); 
  }



  seller: any;
  getProfile() {
    if (!this.isUserLoggedIn()) {
      // console.log('User is not logged in');
      return;
    }
    const apiEndpoint = API_ROUTES.More.moreDetails;
    if (!apiEndpoint) {
      // console.log('API endpoint is undefined');
      return;
    }
    this.service.get({}, apiEndpoint).subscribe({
      next: (response) => {

        this.seller = response?.result[0]?.UserAuths[0]?.company_name;
        // console.log('API response:', this.headerPic);
      },
      error: (err) => {
        console.error('Error fetching profile details:', err);
      }
    });
  }

  enquiry() {
    const screenWidth = window.innerWidth;
    let isSmallScreen = false;
    if (screenWidth <= 1440) {
      isSmallScreen = true;
    }
    let token = localStorage.getItem('stoken');
    if (token) {
      const dialogRef = this.dialogRef.open(EditEnquiryComponent, {
        maxHeight: '100vh',
        width: isSmallScreen ? '1000px' : '1000px',
        // data: {
        //   img: '../.assets/images/report.svg',
        //   heading: 'Enquiry',
        //   para: 'Lorem Ipsum is simply dummy text of the printing text of the printing. ',
        //   report: 'Yes, Logout',
        //   cancel: 'Cancel'
        // }
      });
    }
    else {
      this.toastr.error('Need to login first');
      this.service.Login();
    }
  }

  isUserLoggedIn() {
    const token = localStorage.getItem('stoken');

    if (token) {
      return true;
    } else {

      return false;
    }
  }



  resgetIndustry() {
    this.service.get({}, `${API_ROUTES.Account.getIndustry}`).pipe().subscribe((res) => {
      this.selectedIndustry = res.result;
      this.defaultIndustryId = this.selectedIndustry.length > 0 ? this.selectedIndustry[0].id : null;

      // console.log('222222', this.selectedIndustry);

    })
  }
  postEnquiriesfrom() {
//     if (this.Enquiriesfrom.invalid) {
// console.log('afdgf',this.Enquiriesfrom.invalid)
//       return;
//     }

    this.submitted = true;

    const profileData = this.Enquiriesfrom.value;
    const payload = {
      ...profileData, // Include all form fields in the payload
    };

    const apiUrl = API_ROUTES.TellEnquiries;

    this.service.post(payload, apiUrl, {}).pipe().subscribe((res) => {
      if (res.success == true) {
        this.toastr.success('Form submitted successfully');
        // console.log('Form submitted successfully');
        this.Enquiriesfrom.reset();
        this.resgetIndustry();

        this.dialogRef.open(LogoutComponent, {
          maxHeight: '100vh',
          width: '50%',
          data: {
            img: '../assets/images/new_img/Group.svg',
            heading: 'Your Enquiry has been Submitted',
            para: "We will get back to you as soon as possible."
          }
        })

      } else {
        this.toastr.error(res.message);
        //  console.log(res.message);
      }
    },
      (error) => {
        // console.log(error.result.error, 'ggggg');
        this.toastr.error(error.result.error);

      });


  }

  homeList(nextPageUrl?: string) {
    const apiEndpoint = nextPageUrl || API_ROUTES.HomeList.HomeListing;

    this.service.get({}, apiEndpoint).subscribe({
      next: (res: { success: any; result: any; next?: string }) => {
        if (res && res.success && res.result) {
          this.homeListdata = res.result;
          //  console.log('2222222222', this.homeListdata);

          // Load next page if available
          if (res.next) {
            this.homeList(res.next); // call the same function with next page URL
          }

          // Ensure slick slider is re-initialized after data is loaded
          setTimeout(() => this.initSlick(), 0);
        } else {
          console.warn('API response does not contain success or result');
        }
      },
      error: (error: any) => {
        console.error('API call failed:', error);
      }
    });
  }


  recentlyViewed() {
    if (!this.isUserLoggedIn()) {
      return;
    }

    const apiEndpoint = API_ROUTES.Home.recentlyViewed;
    //console.log('API expToken:', isUserLoggedIn);
    if (!apiEndpoint) return;
    this.service.get({}, apiEndpoint).subscribe({
      next: (response) => {
        this.recentlyViewedItems = response.result;
        //  console.log('9191919191000', this.recentlyViewedItems);
      },
      error: (err) => {
        console.error('Error fetching recently viewed items:', err);
      }
    });
  }


  bannerLists() {
    const apiEndpoint = API_ROUTES.Home.bannerLists;
    //console.log('API expToken:', isUserLoggedIn);
    if (!apiEndpoint) return;
    this.service.get({}, apiEndpoint).subscribe({
      next: (response) => {
        this.bannerListview = response.data;
        // console.log('1111111111', this.bannerListview);
      },
      error: (err) => {
        console.error('Error fetching recently viewed items:', err);
      }
    });
  }
  viewSingleProduct(productId: string) {
    // console.log(category, "category");
    // let token = localStorage.getItem('stoken');
    // if (token) {
      // if (category == 'Machine') {
      //   this.router.navigate([RouteConstant.machine], { queryParams: { productId: productId } }).then(() => {
      //     window.scrollTo(0, 0);
      //   });
      // } else if (category == 'Services') {
      //   this.router.navigate([RouteConstant.service], { queryParams: { productId: productId } }).then(() => {
      //     window.scrollTo(0, 0);
      //   });
      // } else if (category == 'Tools') {
      //   this.router.navigate([RouteConstant.tools], { queryParams: { productId: productId } }).then(() => {
      //     window.scrollTo(0, 0);
      //   });
      // } else if (category == 'Raw Material') {
      //   this.router.navigate([RouteConstant.rawmaterials], { queryParams: { productId: productId } }).then(() => {
      //     window.scrollTo(0, 0);
      //   });
      // }

      this.router.navigate([RouteConstant.productdetail], { queryParams: { productId: productId } });
      window.scrollTo(0, 0);
    // }
    // else {
    //   this.toastr.error('Need to login first');
    //   this.service.Login();
    // }
  }



  recommendedProducts() {
    if (!this.isUserLoggedIn()) {
      return;
    }
    const apiEndpoint = API_ROUTES.Home.recommendedProducts;
    // console.log('API Endpoint:', apiEndpoint);
    if (!apiEndpoint) return;
    this.service.get({}, apiEndpoint).subscribe({
      next: (response) => {
        this.products = response.result;
        // console.log("i am firing after setting value",  this.products)
        //  console.log('productsproductsproductsproducts33333333', this.products);

        // if (response.success && response.result) {
        //   // Log success condition
        //   console.log('Successful response, extracting products...');

        //   // Iterate over each category in the result
        //   const categories = response.result; // Access the result directly

        //   for (const categoryKey in categories) {
        //     if (categories.hasOwnProperty(categoryKey)) {
        //       const category = categories[categoryKey];
        //       console.log(`Processing category: ${categoryKey}`); // Log the current category being processed

        //       const subcategories = category.subcategories; // Access the subcategories
        //       for (const subKey in subcategories) {
        //         if (subcategories.hasOwnProperty(subKey)) {
        //           const subcategory = subcategories[subKey];
        //           console.log(`Processing subcategory: ${subKey}`); // Log the current subcategory
        //           console.log('Products in this subcategory:', subcategory.products); // Log products in the current subcategory

        //           // Spread operator to flatten products into the array
        //           this.products.push(...subcategory.products);
        //         }
        //       }
        //     }
        //   }

        //   console.log('All products collected:', this.products); // Log the final products array
        // } else {
        //   console.warn('Response structure is not as expected:', response); // Log if the response structure is unexpected
        // }
      },
      error: (err) => {
        console?.error('Error fetching products:', err); // Log any errors that occur during the request
      }
    });
  }















  ngAfterViewChecked(): void {
    // Re-initialize slick sliders after each check if necessary

  }

  initSlick(): void {
    // Remove existing slick initialization if any
    $('.slick-slider').each(() => {
      if ($(this).hasClass('slick-initialized')) {
        try {
          $(this).slick('unslick');
        } catch (error) {
          console.warn('Slick slider could not be unslicked:', error);
        }
      }
    });

    if ($('.featuredbanner-slide').hasClass('slick-initialized')) {
      $('.featuredbanner-slide').slick('unslick');
    }

    if ($('.featuredlistings-slide').hasClass('slick-initialized')) {
      $('.featuredlistings-slide').slick('unslick');
    }
    // Re-initialize slick for all sliders on the page
    $('.slick-slider').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3.2,
      slidesToScroll: 3,
      arrows: true,
      autoplay: true,
      prevArrow: '<button type="button" class="slick-prev"><img src="assets/images/new_images/arrow-left.svg" class="" alt=""></button>',
      nextArrow: '<button type="button" class="slick-next"><img src="assets/images/new_images/arrow-right.svg" class="" alt=""></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
            autoplay: true,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            autoplay: true,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true
          }
        }
      ]
    });

    $('.featuredbanner-slide').slick({
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            autoplay: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true

          }
        }
      ]
    });


    $('.featuredlistings-slide').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 2.5,
      slidesToScroll: 3,
      arrows: true,
      autoplay: true,
      prevArrow: '<button type="button" class="slick-prev"><img src="assets/images/new_images/arrow-left.svg" alt=""></button>',
      nextArrow: '<button type="button" class="slick-next"><img src="assets/images/new_images/arrow-right.svg" alt=""></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
            autoplay: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            autoplay: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true
          }
        }
      ]
    });



    $('.slick-slider').each(() => {
      if ($(this).hasClass('slick-initialized')) {
        try {
          $(this).slick('unslick');
        } catch (error) {
          console.warn('Slick slider could not be unslicked:', error);
        }
      }
    });

    if ($('.testimonials-slide').hasClass('slick-initialized')) {
      $('.testimonials-slide').slick('unslick');
    }

    $('.testimonials-slide').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 2.5,
      slidesToScroll: 3,
      arrows: true,
      autoplay: true,
     
      prevArrow: '<button type="button" class="slick-prev"><img src="assets/images/new_images/arrow-left.svg" class="" alt=""></button>',
      nextArrow: '<button type="button" class="slick-next"><img src="assets/images/new_images/arrow-right.svg" class="" alt=""></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
            autoplay: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            autoplay: true,
             mobileFirst: true,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
             mobileFirst: true,
          }
        }
      ]
    });



  }

  navigateToProductListing(product: any, subCategory1Id: string): void {
    // console.log('product',product)

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/main/product-listing'], { queryParams: { industryId: product,        subCategory1Id: subCategory1Id, 
        sortType:'popularity'} });
    })
  }
  navigateTonewArrival(product: any): void {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/main/product-listing'], { queryParams: { industryId: product,sortType:'recent' } });
    })
  }

  navigateStore(status:any): void {
    let token = localStorage.getItem('stoken');
  
    if (token && token.trim() !== '') {
      setTimeout(() => {
        this.router.navigate(['/main/company-profile'], {
          queryParams: { status: status }
        });
      }, 2000); // 2-second delay before navigating
    } else {
      this.toastr.error('No token found. Please log in.', 'Error');
      this.service.Login();
      
    }
  }
  

  
  navigateToDetails(country_origin:any) {
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    } else {
      this.router.navigate([ "/" + RouteConstant.main + "/" + RouteConstant.productListing],{ queryParams: {sortType:'recent',country_origin:country_origin} });
    }
  }
  navigateRecentlyToDetails(){
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    } else {
      this.router.navigate([ "/" + RouteConstant.main + "/" + RouteConstant.productListing],{ queryParams: {recentlyviewed:true} });
    }
  }
  navigateRecommendedToDetails(){
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    } else {
      this.router.navigate([ "/" + RouteConstant.main + "/" + RouteConstant.productListing],{ queryParams: {recommended:true} });
    }
  }

  navigateNewlyArrival(sortType: string='recent') {
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    } else {
      this.router.navigate([ "/" + RouteConstant.main + "/" + RouteConstant.productListing],{ queryParams: {sortType:sortType} });
    }
  }
  navigateToaboutus() {
      this.router.navigate([RouteConstant.aboutUs]);
  }

  navigateServices() {
    const ServicesId ='0627f25d-6d56-4237-b561-d0ea9830acd7';
    const FinanceId='9595821e-9d59-4218-b516-ed77d4aa7a76';
    this.router.navigate(
      ['main/product-listing'], 
      { queryParams: { industryId: ServicesId,subCategory1Id:FinanceId } }
    );
  }

  navigateToAboutUs() {
    // this.router.navigate(['/' + RouteConstant.main + '/' + RouteConstant.profile + '/' +  RouteConstant.aboutUs ]);
    this.router.navigate([RouteConstant.aboutUs]);

  }

}